module.exports = __webpack_public_path__ + "assets/images/skai.ed7afdaf4af75d5dea0b9df43960bf6a.png";